export const EncKeys = {
    VayanaEncKey: '6fa979f20126cb08aa645a8f495f6d85',
    IV: '4512631236589784',
}